import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { resetPasswordFields } from "../../constants/formFields"
import FormAction from "../forms/FormAction"
import Input from "../forms/Input"
import { FieldState } from "../../Interfaces"
import { authService } from "../../services/authService"

const fields = resetPasswordFields
const fieldsState: FieldState = {}
fields.forEach((field) => (fieldsState[field.id] = ""))

export default function RequestAccountDeletion() {
  const [formState, setFormState] = useState(fieldsState)
  const [submitting, setSubmitting] = useState(false)
  const navigate = useNavigate()

  const handleChange = (e: { target: { id: string; value: string } }) => {
    setFormState({ ...formState, [e.target.id]: e.target.value })
  }

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault()
    setSubmitting(true)
    try {
      await authService.requestAccountDeletion(formState.email.trim())
      navigate("/deleteAccount/email-sent")
    } catch {
      alert("Something went wrong. Please try again later.")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
      <div className="-space-y-px">
        {fields.map((field) => (
          <Input
            className="bg-gray-50 border-gray-300"
            key={field.id}
            handleChange={handleChange}
            value={formState[field.id]}
            labelText={field.labelText}
            labelFor={field.labelFor}
            id={field.id}
            name={field.name}
            type={field.type}
            isRequired={field.isRequired}
            placeholder={field.placeholder}
          />
        ))}
      </div>
      <FormAction handleSubmit={handleSubmit} text={submitting ? "Sending…" : "Request deletion"} />
    </form>
  )
}
